import { AlertMessageLink } from '@/app/components'
import { useAppDispatch } from '@/hooks'
import { EnergySystemDemandResponseEvent } from '@/types/energySystemDemandResponseEvent'
import EnergySystemDROptOutModal from './EnergySystemDROptOutModal'
import { EnergySystem } from '@/types/energySystem'
import EnergySystemDROptInModal from './EnergySystemDROptInModal'
import { optInToEnergySystemDemandResponseEventAction } from '@/reducers/energySystemDemandResponseEvents'
import { getActiveEventText, useDRAlertModalLink } from './utils'

type Props = {
  event: EnergySystemDemandResponseEvent
  energySystem: EnergySystem
}

const OPEN_OPT_OUT_MODAL_QUERY_PARAM = 'es-active-event-out-modal'
const OPEN_OPT_IN_STATUS_MODAL_QUERY_PARAM = 'es-active-event-in-modal'

export function useViewModel(props: Props) {
  const { event } = props
  const dispatch = useAppDispatch()

  const alertText = getActiveEventText(event)

  const {
    linkTo,
    linkText,
    optOutModalOpen,
    onOptOutModalClose,
    onOptInStatusModalClose,
    optInStatusModalOpen,
  } = useDRAlertModalLink({
    event,
    outParam: OPEN_OPT_OUT_MODAL_QUERY_PARAM,
    inParam: OPEN_OPT_IN_STATUS_MODAL_QUERY_PARAM,
  })

  const onLinkClick = () => {
    if (!event.enrolled) {
      dispatch(
        optInToEnergySystemDemandResponseEventAction(
          String(props.energySystem.id),
          event.id,
        ),
      )
    }
  }

  return {
    linkTo,
    linkText,
    onLinkClick,
    optOutModalOpen,
    onOptOutModalClose,
    onOptInStatusModalClose,
    optInStatusModalOpen,
    alertText,
  }
}

export default function EnergySystemActiveDRAlert(props: Props) {
  const {
    linkTo,
    linkText,
    onLinkClick,
    optOutModalOpen,
    onOptOutModalClose,
    optInStatusModalOpen,
    alertText,
    onOptInStatusModalClose,
  } = useViewModel(props)
  return (
    <>
      <AlertMessageLink
        variant="info"
        linkText={linkText}
        linkTo={linkTo}
        onLinkClick={onLinkClick}
      >
        {alertText}
      </AlertMessageLink>
      <EnergySystemDROptOutModal
        energySystem={props.energySystem}
        event={props.event}
        open={optOutModalOpen}
        onClose={onOptOutModalClose}
        eventIsActive
      />
      <EnergySystemDROptInModal
        event={props.event}
        open={optInStatusModalOpen}
        onClose={onOptInStatusModalClose}
      />
    </>
  )
}
